
























































































































import { Vue } from 'vue-property-decorator';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoForm from '@/components/Molecules/co-form/CoForm.vue';

interface BillingAddress {
    Phone?: string;
    Company?: string;
    AdditionalInfo?: string;
    Address: string;
    PostalCode: string;
    City: string;
    Country: string;
    VATNumber?: string;
}

export default Vue.extend({
    name: 'CoCardBillingAddress',
    components: { CoModal, CoCard, CoForm },
    props: {
        billingAddress: {
            type: Object as () => BillingAddress,
            default: null,
        },
        userName: {
            type: String,
            default: '',
        },
        saveBillingAddressData: {
            type: Function,
            default: () => {},
        },
        variant: {
            type: String,
            default: 'normal',
            required: false,
        },
        validateOnMount: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {};
    },

    methods: {
        openBillingAddressModal() {
            this.$refs['modal-edit-billing-address'].show();
        },
        async saveBillingAddress(formData: BillingAddress) {
            const data = { ...formData };
            // strip whitespace from VAT number if exists
            if (data.VATNumber) {
                data.VATNumber = data.VATNumber.replace(/\s/g, '');
            }

            await this.saveBillingAddressData(data);
            this.$refs['modal-edit-billing-address'].hide();
        },
        cancelBillingAddress() {
            this.$refs['modal-edit-billing-address'].hide();
        },
    },
});
